import { useContext, useEffect, useMemo } from 'react';
import {
  number, node, any, bool,
} from 'prop-types';
import Link from 'next/link';
import { Spin } from 'antd';

import { categories } from 'utils/myaccount';
import { i18nContext } from 'context/i18n';
import { userContext } from 'context/user';
import { MyAccountFormWrapper } from 'components/myAccount';

import { useRouter } from 'next/router';
import { useLink } from 'hooks';
import { IS_NNORMAL } from 'utils/constants/system';
import styles from './style.module.css';

export default function MyAccountLayout({
  children, activePanel, contentClassName, withCategories, withAuth, withCategoriesLayout, formWrapperStyles,
}) {
  const { t, locale } = useContext(i18nContext);
  const { userData, loading, shouldLogin } = useContext(userContext);
  const router = useRouter();
  const to = useLink();
  const unauthorizedNWUser = useMemo(() => IS_NNORMAL && userData?.account?.kboix === false && router.asPath.includes('nnormal-world'), [ userData?.account?.kboix ]);

  useEffect(() => {
    if (unauthorizedNWUser) {
      window.location.assign(to('/myaccount'));
    }
  }, [ unauthorizedNWUser ]);

  if ((withAuth && userData === null) || (withAuth && unauthorizedNWUser)) {
    return (
      <Spin spinning={loading}>
        <div className={!formWrapperStyles ? styles.layoutLogin : `${styles.layoutLogin} ${formWrapperStyles}`}>
          {!shouldLogin ?
            <p className={styles.authenticating}>{t('mi.cuenta', 'autentificando', 'Authenticating...')}</p> :
            <MyAccountFormWrapper locale={locale} onSuccess={() => { window.location.assign(`${window.location.origin}/${locale}/myaccount`); } } />
          }
        </div>
      </Spin>
    );
  }

  if (!withCategoriesLayout) {
    return (<>{children}</>);
  }

  return (
    <div className={styles.layoutContainer}>
      <nav className={styles.nav}>
        {withCategories &&
          <ul>
            <li key="Home" className={styles.navItem}>
              <a href={`/${locale}/myaccount`}>{t('mi.cuenta', 'home', 'Home')}</a>
            </li>
            {categories
              .filter((item) => (item.condition ? item.condition(userData) : true))
              .map((category, index) => (
              <li key={category.title} className={index !== activePanel ? styles.navItem : `${styles.navItem} ${styles.navItemActive}`}>
                {category.link ? <Link shallow={true} href={`/${locale}${category.link}`}>{t(...category.title)}</Link> : t(...category.title)}
              </li>
              ))
            }
          </ul>
        }
      </nav>
      <div className={contentClassName ? `${contentClassName} ${styles.content}` : styles.content}>
        {children}
      </div>
    </div>
  );
}

MyAccountLayout.propTypes = {
  children: node,
  activePanel: number,
  contentClassName: any,
  withCategories: bool,
  withAuth: bool,
  withCategoriesLayout: bool,
  formWrapperStyles: any,
};

MyAccountLayout.defaultProps = {
  contentClassName: null,
  withCategories: true,
  withAuth: true,
  withCategoriesLayout: true,
};
